import React, { useContext, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { UserContext } from './UserContext';
import { IoMdPerson } from 'react-icons/io';
import { HiMenu, HiX } from 'react-icons/hi';

function OurNavbar() {
  const {
    userId,
    setUserId,
    userName,
    currentSubscription,
    profileImageUrl,
    lastname,
  } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    setUserId(null);
    navigate('/login');
    setIsOpen(false);
  };

  const goToProfilePage = () => {
    navigate('/edit-profile');
    setIsOpen(false);
  };

  return (
    <nav className="bg-[#f7fbee] border-b border-green-100">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        {' '}
        {/* Removed max-w-7xl */}
        <div className="flex justify-between h-20">
          {' '}
          {/* Increased height */}
          {/* Logo Section - Aligned to left edge */}
          <div className="flex-shrink-0 flex items-center pl-2">
            <Link to="/">
              <img
                className="h-12 w-auto" /* Increased logo size */
                src={process.env.PUBLIC_URL + '/img/asquad-logo-v3.png'}
                alt="ASquad"
              />
            </Link>
          </div>
          {/* Desktop Menu - Aligned to right edge */}
          <div className="hidden sm:flex sm:items-center sm:pr-2">
            {userId ? (
              <div className="relative">
                <div>
                  <button
                    onClick={() => setIsOpen(!isOpen)}
                    className="flex items-center space-x-3 text-gray-700 hover:text-gray-900 focus:outline-none"
                  >
                    <span className="text-sm font-medium">
                      {userName && userName} {lastname && lastname}
                    </span>
                    {profileImageUrl ? (
                      <div className="rounded-full p-0.5 bg-gradient-to-r from-green-600 to-lime-500">
                        <img
                          src={profileImageUrl}
                          alt="Profile"
                          className="h-10 w-10 rounded-full object-cover border-2 border-white"
                        />
                      </div>
                    ) : (
                      <div className="h-11 w-11 rounded-full bg-gradient-to-r from-green-600 to-lime-500 flex items-center justify-center">
                        <IoMdPerson className="text-white text-2xl" />
                      </div>
                    )}
                  </button>
                </div>

                {/* Dropdown Menu - Right aligned */}
                {isOpen && (
                  <div className="absolute right-0 mt-2 w-36 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5">
                    <div
                      onClick={goToProfilePage}
                      className="px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer flex items-center justify-end space-x-2"
                    >
                      <span>Profile</span>
                      <IoMdPerson className="text-gray-500" />
                    </div>
                    {currentSubscription && (
                      <Link
                        to="/plans"
                        className="px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center justify-end space-x-2"
                      >
                        <span>
                          {currentSubscription?.data?.plan?.plan === 'Premium'
                            ? 'Premium'
                            : 'Free Plan'}
                        </span>
                        <span className="h-2 w-2 rounded-full bg-green-500" />
                      </Link>
                    )}
                    <div
                      onClick={logout}
                      className="px-3 py-2 text-sm text-red-600 hover:bg-red-50 cursor-pointer text-right"
                    >
                      Sign out
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="flex items-center space-x-4">
                <Link
                  to="/signup"
                  className="text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium"
                >
                  Sign up
                </Link>
                <Link
                  to="/login"
                  className="bg-gradient-to-r from-green-600 to-lime-500 text-white px-4 py-2 rounded-full text-sm font-medium hover:shadow-lg transition-shadow duration-200"
                >
                  Log in
                </Link>
              </div>
            )}
          </div>
          {/* Mobile menu button */}
          <div className="flex items-center sm:hidden pr-2">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-100 focus:outline-none"
            >
              {isOpen ? (
                <HiX className="block h-6 w-6" />
              ) : (
                <HiMenu className="block h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="sm:hidden">
          <div className="pt-2 pb-3 space-y-1">
            {userId ? (
              <div className="space-y-1 px-4">
                <div
                  onClick={goToProfilePage}
                  className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 rounded-md cursor-pointer text-right"
                >
                  Profile
                </div>
                {currentSubscription && (
                  <Link
                    to="/plans"
                    className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 rounded-md text-right"
                  >
                    {currentSubscription?.data?.plan?.plan === 'Premium'
                      ? 'Premium'
                      : 'Free Plan'}
                  </Link>
                )}
                <div
                  onClick={logout}
                  className="block px-3 py-2 text-base font-medium text-red-600 hover:bg-red-50 rounded-md cursor-pointer text-right"
                >
                  Sign out
                </div>
              </div>
            ) : (
              <div className="space-y-1 px-4">
                <Link
                  to="/signup"
                  className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 rounded-md text-right"
                >
                  Sign up
                </Link>
                <Link
                  to="/login"
                  className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 rounded-md text-right"
                >
                  Log in
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}

export default OurNavbar;
